import { render, staticRenderFns } from "./message-wrapper.vue?vue&type=template&id=3fb2f27c&"
import script from "./message-wrapper.vue?vue&type=script&lang=js&"
export * from "./message-wrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports